export const RoleEnum = {
  Admin: 0,
  Developer: 1,
  Student: 2,
  Professor: 3,
  Director: 4,
  Researcher: 5,
}
